module.exports = __webpack_public_path__ + "img/login_screen.57afb1c9.jpg";